import { iconMap } from './svg-to-font-icon-map';
import { xtuiButtonStyle } from '@xt/ui-kit';
import {
  booleanAttribute,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'xt-portal-button',
  templateUrl: './button.component.html',
  standalone: false,
})
export class ButtonComponent {
  @ViewChild('button', { read: ElementRef }) button: ElementRef;
  @Input() text: string;
  @Input() icon: string;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() iconLabel?: string;
  @Input() ariaLabel?: string;
  @Input() textAlign: 'left' | 'right' | 'center' = 'center';
  @Input() color: string | 'primary' | 'accent' | 'warn' | 'light-blue' =
    'primary';
  @Input() style: xtuiButtonStyle = 'flat';
  @Input() size: string = null;
  @Input() width: 'full' | 'normal' | 'small' | 'medium' | 'large' = 'normal';
  @Input() isDropdown: boolean = false;
  @Input() isActive: boolean = false;
  @Input() loading: boolean = false;
  @Input({ transform: booleanAttribute }) disabled: boolean = false;
  @Input() disableRipple: boolean = false;

  // dataCy attribute is required in xt-ui-kit-button
  // but on Curamenta we are using xTentionDummyCypress directive
  @Input() dataCy: string = '';

  @Output() clickEvent: EventEmitter<any> = new EventEmitter();

  /**
   * click handler, that emits event when button is clicked
   */
  onClickHandler() {
    if (!this.disabled) {
      this.clickEvent.emit();
    }
  }

  focus() {
    this.button.nativeElement.focus();
  }

  getIcon() {
    return iconMap.get(this.icon) || this.icon;
  }

  getSize() {
    switch (this.size) {
      case 'small':
        return 'small';
      case 'large':
        return 'large';
      default:
        return 'default';
    }
  }
}
